// Version : 1.0.0
// Author : AGALYA
import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** CURRENT ADDRESS ADD START *********************** */
export const currentMemberAddressAdd = (verifyData: any) => {
	const data = {
		CreateCurrentAddressToken: verifyData,
	};
	const url = `${API_URL}addCurrentAddress`;
	return makeApiCall(url, data);
};
/** ***************** CURRENT ADDRESS ADD END *********************** */
